'use strict';

var cov_29f32rpwpq = function () {
  var path = '/codebuild/output/src2823567348/src/apps/tnwi/temp/nucleo/streamOnline/lib/actions.js',
      hash = '4a84b5f0792a23cf4d70d3837b65f9b0a885da9e',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src2823567348/src/apps/tnwi/temp/nucleo/streamOnline/lib/actions.js',
    statementMap: {
      '0': {
        start: {
          line: 4,
          column: 28
        },
        end: {
          line: 6,
          column: 2
        }
      },
      '1': {
        start: {
          line: 4,
          column: 35
        },
        end: {
          line: 6,
          column: 1
        }
      },
      '2': {
        start: {
          line: 8,
          column: 29
        },
        end: {
          line: 11,
          column: 2
        }
      },
      '3': {
        start: {
          line: 8,
          column: 38
        },
        end: {
          line: 11,
          column: 1
        }
      },
      '4': {
        start: {
          line: 13,
          column: 27
        },
        end: {
          line: 16,
          column: 2
        }
      },
      '5': {
        start: {
          line: 13,
          column: 44
        },
        end: {
          line: 16,
          column: 1
        }
      },
      '6': {
        start: {
          line: 18,
          column: 37
        },
        end: {
          line: 20,
          column: 2
        }
      },
      '7': {
        start: {
          line: 18,
          column: 44
        },
        end: {
          line: 20,
          column: 1
        }
      },
      '8': {
        start: {
          line: 22,
          column: 25
        },
        end: {
          line: 25,
          column: 2
        }
      },
      '9': {
        start: {
          line: 22,
          column: 39
        },
        end: {
          line: 25,
          column: 1
        }
      },
      '10': {
        start: {
          line: 27,
          column: 31
        },
        end: {
          line: 29,
          column: 1
        }
      },
      '11': {
        start: {
          line: 27,
          column: 44
        },
        end: {
          line: 29,
          column: 1
        }
      },
      '12': {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 28,
          column: 40
        }
      },
      '13': {
        start: {
          line: 31,
          column: 32
        },
        end: {
          line: 55,
          column: 1
        }
      },
      '14': {
        start: {
          line: 31,
          column: 64
        },
        end: {
          line: 55,
          column: 1
        }
      },
      '15': {
        start: {
          line: 33,
          column: 2
        },
        end: {
          line: 33,
          column: 34
        }
      },
      '16': {
        start: {
          line: 35,
          column: 2
        },
        end: {
          line: 54,
          column: 7
        }
      },
      '17': {
        start: {
          line: 41,
          column: 6
        },
        end: {
          line: 45,
          column: 7
        }
      },
      '18': {
        start: {
          line: 42,
          column: 30
        },
        end: {
          line: 42,
          column: 43
        }
      },
      '19': {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 43,
          column: 54
        }
      },
      '20': {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 44,
          column: 41
        }
      },
      '21': {
        start: {
          line: 46,
          column: 20
        },
        end: {
          line: 46,
          column: 76
        }
      },
      '22': {
        start: {
          line: 47,
          column: 6
        },
        end: {
          line: 47,
          column: 51
        }
      },
      '23': {
        start: {
          line: 48,
          column: 6
        },
        end: {
          line: 48,
          column: 18
        }
      },
      '24': {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 51,
          column: 49
        }
      },
      '25': {
        start: {
          line: 52,
          column: 6
        },
        end: {
          line: 52,
          column: 102
        }
      },
      '26': {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 53,
          column: 22
        }
      },
      '27': {
        start: {
          line: 57,
          column: 36
        },
        end: {
          line: 59,
          column: 1
        }
      },
      '28': {
        start: {
          line: 57,
          column: 42
        },
        end: {
          line: 59,
          column: 1
        }
      },
      '29': {
        start: {
          line: 58,
          column: 2
        },
        end: {
          line: 58,
          column: 43
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 4,
            column: 28
          },
          end: {
            line: 4,
            column: 29
          }
        },
        loc: {
          start: {
            line: 4,
            column: 35
          },
          end: {
            line: 6,
            column: 1
          }
        },
        line: 4
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 8,
            column: 29
          },
          end: {
            line: 8,
            column: 30
          }
        },
        loc: {
          start: {
            line: 8,
            column: 38
          },
          end: {
            line: 11,
            column: 1
          }
        },
        line: 8
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 13,
            column: 28
          }
        },
        loc: {
          start: {
            line: 13,
            column: 44
          },
          end: {
            line: 16,
            column: 1
          }
        },
        line: 13
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 18,
            column: 37
          },
          end: {
            line: 18,
            column: 38
          }
        },
        loc: {
          start: {
            line: 18,
            column: 44
          },
          end: {
            line: 20,
            column: 1
          }
        },
        line: 18
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 22,
            column: 25
          },
          end: {
            line: 22,
            column: 26
          }
        },
        loc: {
          start: {
            line: 22,
            column: 39
          },
          end: {
            line: 25,
            column: 1
          }
        },
        line: 22
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 27,
            column: 31
          },
          end: {
            line: 27,
            column: 32
          }
        },
        loc: {
          start: {
            line: 27,
            column: 44
          },
          end: {
            line: 29,
            column: 1
          }
        },
        line: 27
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 27,
            column: 44
          },
          end: {
            line: 27,
            column: 45
          }
        },
        loc: {
          start: {
            line: 27,
            column: 56
          },
          end: {
            line: 29,
            column: 1
          }
        },
        line: 27
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 31,
            column: 32
          },
          end: {
            line: 31,
            column: 33
          }
        },
        loc: {
          start: {
            line: 31,
            column: 64
          },
          end: {
            line: 55,
            column: 1
          }
        },
        line: 31
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 31,
            column: 64
          },
          end: {
            line: 31,
            column: 65
          }
        },
        loc: {
          start: {
            line: 31,
            column: 76
          },
          end: {
            line: 55,
            column: 1
          }
        },
        line: 31
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 40,
            column: 10
          },
          end: {
            line: 40,
            column: 11
          }
        },
        loc: {
          start: {
            line: 40,
            column: 22
          },
          end: {
            line: 49,
            column: 5
          }
        },
        line: 40
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 50,
            column: 11
          },
          end: {
            line: 50,
            column: 12
          }
        },
        loc: {
          start: {
            line: 50,
            column: 23
          },
          end: {
            line: 54,
            column: 5
          }
        },
        line: 50
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 57,
            column: 36
          },
          end: {
            line: 57,
            column: 37
          }
        },
        loc: {
          start: {
            line: 57,
            column: 42
          },
          end: {
            line: 59,
            column: 1
          }
        },
        line: 57
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 57,
            column: 42
          },
          end: {
            line: 57,
            column: 43
          }
        },
        loc: {
          start: {
            line: 57,
            column: 54
          },
          end: {
            line: 59,
            column: 1
          }
        },
        line: 57
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 45,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 45,
            column: 7
          }
        }, {
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 45,
            column: 7
          }
        }],
        line: 41
      },
      '1': {
        loc: {
          start: {
            line: 41,
            column: 10
          },
          end: {
            line: 41,
            column: 57
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 41,
            column: 10
          },
          end: {
            line: 41,
            column: 32
          }
        }, {
          start: {
            line: 41,
            column: 36
          },
          end: {
            line: 41,
            column: 57
          }
        }],
        line: 41
      },
      '2': {
        loc: {
          start: {
            line: 44,
            column: 15
          },
          end: {
            line: 44,
            column: 40
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 44,
            column: 15
          },
          end: {
            line: 44,
            column: 28
          }
        }, {
          start: {
            line: 44,
            column: 32
          },
          end: {
            line: 44,
            column: 40
          }
        }],
        line: 44
      },
      '3': {
        loc: {
          start: {
            line: 47,
            column: 23
          },
          end: {
            line: 47,
            column: 50
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 47,
            column: 23
          },
          end: {
            line: 47,
            column: 38
          }
        }, {
          start: {
            line: 47,
            column: 42
          },
          end: {
            line: 47,
            column: 50
          }
        }],
        line: 47
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gAxios = require('@gravity/g-axios');

var _gAxios2 = _interopRequireDefault(_gAxios);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cov_29f32rpwpq.s[0]++;


var getBeforeLoadAction = function getBeforeLoadAction() {
  cov_29f32rpwpq.f[0]++;
  cov_29f32rpwpq.s[1]++;
  return {
    type: _constants2.default.STREAM_ONLINE_BEFORE_LOAD
  };
};

cov_29f32rpwpq.s[2]++;
var getLoadSuccessAction = function getLoadSuccessAction(data) {
  cov_29f32rpwpq.f[1]++;
  cov_29f32rpwpq.s[3]++;
  return {
    type: _constants2.default.STREAM_ONLINE_LOAD_SUCCESS,
    data: data
  };
};

cov_29f32rpwpq.s[4]++;
var getLoadErrorAction = function getLoadErrorAction(dialogAction) {
  cov_29f32rpwpq.f[2]++;
  cov_29f32rpwpq.s[5]++;
  return {
    type: _constants2.default.STREAM_ONLINE_LOAD_ERROR,
    dialogAction: dialogAction
  };
};

cov_29f32rpwpq.s[6]++;
var getInitialStreamOnlineAction = function getInitialStreamOnlineAction() {
  cov_29f32rpwpq.f[3]++;
  cov_29f32rpwpq.s[7]++;
  return {
    type: _constants2.default.STREAM_ONLINE_INITIAL_STATE
  };
};

cov_29f32rpwpq.s[8]++;
var updateVisibility = function updateVisibility(isVisible) {
  cov_29f32rpwpq.f[4]++;
  cov_29f32rpwpq.s[9]++;
  return {
    type: _constants2.default.STREAM_ONLINE_UPDATE_DIALOG_VISIBILITY,
    isVisible: isVisible
  };
};

cov_29f32rpwpq.s[10]++;
var updateDialogVisibility = function updateDialogVisibility(isVisible) {
  cov_29f32rpwpq.f[5]++;
  cov_29f32rpwpq.s[11]++;
  return function (dispatch) {
    cov_29f32rpwpq.f[6]++;
    cov_29f32rpwpq.s[12]++;

    dispatch(updateVisibility(isVisible));
  };
};

cov_29f32rpwpq.s[13]++;
var createStreamOnlineOrder = function createStreamOnlineOrder(config, data, dialogAction) {
  cov_29f32rpwpq.f[7]++;
  cov_29f32rpwpq.s[14]++;
  return function (dispatch) {
    cov_29f32rpwpq.f[8]++;
    cov_29f32rpwpq.s[15]++;

    // first dispatch the beforeLoad action
    dispatch(getBeforeLoadAction());

    cov_29f32rpwpq.s[16]++;
    return (0, _gAxios2.default)(config.restHost + '/v1/stream-online', {
      headers: config.headers,
      method: 'POST',
      data: data
    }).then(function (response) {
      cov_29f32rpwpq.f[9]++;
      cov_29f32rpwpq.s[17]++;

      if ((cov_29f32rpwpq.b[1][0]++, response.status >= 200) && (cov_29f32rpwpq.b[1][1]++, response.status < 300)) {
        cov_29f32rpwpq.b[0][0]++;

        var streamContent = (cov_29f32rpwpq.s[18]++, response.data);
        cov_29f32rpwpq.s[19]++;
        dispatch(getLoadSuccessAction(streamContent));
        cov_29f32rpwpq.s[20]++;
        return (cov_29f32rpwpq.b[2][0]++, streamContent) || (cov_29f32rpwpq.b[2][1]++, response);
      } else {
        cov_29f32rpwpq.b[0][1]++;
      }
      var error = (cov_29f32rpwpq.s[21]++, new Error(response.status + ' (' + response.statusText + ')'));
      cov_29f32rpwpq.s[22]++;
      error.response = (cov_29f32rpwpq.b[3][0]++, response.json()) || (cov_29f32rpwpq.b[3][1]++, response);
      cov_29f32rpwpq.s[23]++;
      throw error;
    }).catch(function (response) {
      cov_29f32rpwpq.f[10]++;
      cov_29f32rpwpq.s[24]++;

      dispatch(getLoadErrorAction(dialogAction));
      cov_29f32rpwpq.s[25]++;
      (0, _gAxios.logError)((0, _gAxios.getFrontEndErrorFromAxiosError)(response), config.headers, config.widgetInfo, response);
      cov_29f32rpwpq.s[26]++;
      return response;
    });
  };
};

cov_29f32rpwpq.s[27]++;
var initializeStreamOnlineState = function initializeStreamOnlineState() {
  cov_29f32rpwpq.f[11]++;
  cov_29f32rpwpq.s[28]++;
  return function (dispatch) {
    cov_29f32rpwpq.f[12]++;
    cov_29f32rpwpq.s[29]++;

    dispatch(getInitialStreamOnlineAction());
  };
};

exports.default = { updateDialogVisibility: updateDialogVisibility, createStreamOnlineOrder: createStreamOnlineOrder, initializeStreamOnlineState: initializeStreamOnlineState };